import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFolderSparkle"><Path d="M10.4014 3L12.4014 6H22V20H7.39062L7.55957 19.5596L10.5 18.4307V15.5693L7.55957 14.4395L6.43066 11.5H3.56934L2.43945 14.4395L2 14.6084V3H10.4014Z" fill="currentColor"/><Path d="M5.4 13H4.6L3.6 15.6L1 16.6V17.4L3.6 18.4L4.6 21H5.4L6.4 18.4L9 17.4V16.6L6.4 15.6L5.4 13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderSparkle;
